import removeMd from 'remove-markdown';

class Article {
  constructor({
    id = 0,
    slug = '',
    title = '',
    category = 'support',
    body = '',
    status = 'draft',
    isPublic = false,
    topic = '',
    containsVideo = false,
    fav = false,
  } = {}) {
    this.id = id;
    this.slug = slug;
    this.title = title;
    this.category = category;
    this.body = body || '';
    this.status = status;
    this.isPublic = isPublic;
    this.topic = topic;
    this.fav = fav;
    this.containsVideo = containsVideo;
  }

  get summary() {
    return removeMd(this.body.substr(0, 80));
  }

  clone() {
    return new Article(this);
  }

  toApiFormat() {
    return {
      ID: this.id,
      Slug: this.slug,
      Title: this.title,
      Category: this.category,
      Body: this.body,
      Status: this.status,
      Public: this.isPublic,
      Topic: this.topic,
      Fav: this.fav,
      ContainsVideo: this.containsVideo,
    };
  }

  static fromApiFormat(api) {
    return new Article({
      id: api.ID,
      slug: api.Slug,
      title: api.Title,
      category: api.Category,
      body: api.Body,
      status: api.Status,
      isPublic: api.Public,
      topic: api.Topic,
      fav: api.Fav,
      containsVideo: api.ContainsVideo,
    });
  }
}

export default Article;
